import React, { useState } from 'react'
import ButtonSelector from '../../common/button-selector'
import { Button } from 'react-bootstrap'
import List from '../list'
import Calendar from '../calendar'
import useCurrentUser from '../../../hooks/use-current-user'

const MODES = {
    CALENDAR: 'calendar',
    LIST: 'list',
    
}

const ScheduleScreen = () => {

    const [ mode, setMode ] = useState(MODES.CALENDAR)
    const { id } = useCurrentUser()

    const renderMode = () => {
        switch (mode) {
        case MODES.CALENDAR: return (<Calendar userId={id} />)
        default: return (<List userId={id} />)
        }
    }

    return (
        <div
            style={{
                minHeight: '100%',
                display: 'flex',
                flexDirection: 'column'
            }}
        >
            <div className='text-center'>
                <ButtonSelector
                    options={Object.values(MODES)}
                    value={mode}
                    onChange={setMode}
                />
            </div>
            <div style={{ flexGrow: '1',  }} className=''>
                {renderMode()}
            </div>
            
        </div>
    )
}

export default ScheduleScreen